
import moment from 'moment';
export class TimeFormatValueConverter {

    public toView(value: any): string {
        if (value === undefined || value === null) {
            return value;
        }

        return moment(value).locale(navigator.language).format('LTS');
    }
}
